import React from 'react';
interface Feature {
  icon: ReactNode;
  title: string;
  description: string;
}
interface TechFeatureSectionProps {
  title: string;
  subtitle?: string;
  features: Feature[];
}
export function TechFeatureSection({
  title,
  subtitle,
  features
}: TechFeatureSectionProps) {
  return <div className="bg-white py-16 relative overflow-hidden" data-id="element-1021">
      {/* Tech background elements */}
      <div className="absolute inset-0 tech-grid opacity-10" data-id="element-1022"></div>
      <div className="absolute top-0 right-0 w-64 h-64 bg-blue-50 rounded-full -mr-32 -mt-32 opacity-70 blur-3xl" data-id="element-1023"></div>
      <div className="absolute bottom-0 left-0 w-64 h-64 bg-indigo-50 rounded-full -ml-32 -mb-32 opacity-70 blur-3xl" data-id="element-1024"></div>
      <div className="container mx-auto px-4 relative z-10" data-id="element-1025">
        <div className="text-center mb-12" data-id="element-1026">
          <h2 className="text-3xl font-bold text-gray-900 mb-4 relative inline-block" data-id="element-1027">
            {title}
            <div className="absolute -z-10 w-full h-2 bg-blue-100 bottom-1 left-0 transform -rotate-1" data-id="element-1028"></div>
          </h2>
          {subtitle && <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-1029">
              {subtitle}
            </p>}
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-1030">
          {features.map((feature, index) => <div key={index} className="bg-white p-6 rounded-lg border border-gray-100 shadow-sm hover:shadow-md transition-all duration-300 transform hover:-translate-y-1 relative group" data-id="element-1031">
              <div className="absolute inset-0 bg-gradient-to-br from-blue-50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity rounded-lg" data-id="element-1032"></div>
              <div className="bg-blue-50 w-12 h-12 rounded-lg flex items-center justify-center mb-4 text-blue-600 relative z-10 group-hover:scale-110 transition-transform overflow-hidden" data-id="element-1033">
                <div className="relative z-10" data-id="element-1034">{feature.icon}</div>
                <div className="absolute inset-0 bg-gradient-to-br from-blue-100 to-indigo-50 opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-1035"></div>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2 relative z-10 group-hover:text-blue-700 transition-colors" data-id="element-1036">
                {feature.title}
              </h3>
              <p className="text-gray-600 relative z-10 group-hover:text-gray-700 transition-colors" data-id="element-1037">
                {feature.description}
              </p>
              {/* Corner decoration */}
              <div className="absolute top-0 right-0 w-8 h-8 opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-1038">
                <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-1039">
                  <path d="M0 0L32 0L32 32L0 0Z" fill="rgba(59, 130, 246, 0.1)" data-id="element-1040" />
                </svg>
              </div>
            </div>)}
        </div>
      </div>
    </div>;
}